module.exports = __webpack_public_path__ + "img/michael.db4f3ef3.jpg";